import binder from 'classnames/bind';
import s from './style.module.scss';
import { FlexProps } from 'common/components/Flex/types';
import React, { MouseEventHandler } from 'react';
import { computeHeight, computeWidth } from 'common/components/utils.ts';

const boundedClassNames = binder.bind(s);

export type ClickableProps = FlexProps & {
  onClick: MouseEventHandler<HTMLButtonElement>;
  disableHoverEffect?: boolean;
} & Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'onClick' | 'children' | 'className'>;

const ClickableFlex = React.forwardRef<HTMLButtonElement, ClickableProps>(
  (
    {
      justify = 'center',
      align = 'center',
      row = false,
      className,
      children,
      flex,
      height,
      width,
      wrap,
      bgColor,
      color,
      onClick,
      style,
      disableHoverEffect = true,
      type = 'button',
      ...rest
    }: ClickableProps,
    ref,
  ) => (
    <button
      {...rest}
      ref={ref}
      type={type}
      className={boundedClassNames({
        clickable: true,
        [`justify-${justify}`]: justify,
        [`align-${align}`]: align,
        row,
        column: !row,
        wrap,
        'disable-hover': disableHoverEffect,
      })
        .concat(' ', className || ' ')
        .concat(` bg-${bgColor}`)
        .concat(` text-${color}`)}
      style={{
        flex,
        ...computeHeight(height, true),
        ...computeWidth(width, true),
        ...style,
      }}
      onClick={onClick}
    >
      {children}
    </button>
  ),
);

ClickableFlex.displayName = 'ClickableFlex';
export default ClickableFlex;
